import { getNavigationId } from '@helpers/navigationTitle';
import { isSSR } from '@helpers/ssr';
import Minus from '@img/icons/icon-minus.svg';
import Plus from '@img/icons/plus.svg';
import { Column } from '@stories/Settings/Grids/Grid.styles';
import React, { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ProductDetailsSectionStyles as S } from './LazyProductDetailsSection.styles';
export interface ProductDetailsSectionProps {
  title?: string | null;
  navigationTitle: string | null;
  subHeader?: ReactNode;
  useLegacyContainer?: boolean;
  openByDefault?: boolean;
  queryParam?: string;
}

const LazyProductDetailsSection: FunctionComponent<ProductDetailsSectionProps> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!props.openByDefault);
  const location = useLocation();

  const Container = props.useLegacyContainer ? S.LegacyContainer : S.Grid;

  useEffect(() => {
    if (`${location.hash}`.toLowerCase() === `#${getNavigationId(props.navigationTitle)}`.toLowerCase()) {
      setIsOpen(true);
      return;
    }

    if (props.queryParam) {
      const params = new URLSearchParams(location.search);

      switch (props.queryParam) {
        case 'openReviews': {
          if (params.get(props.queryParam) === '1') {
            setIsOpen(true);
          }
          break;
        }
        case 'serialNumber': {
          if (params.get(props.queryParam) !== null) {
            const section = document.querySelector(`#${getNavigationId(props.navigationTitle)}`);
            if (section) {
              // 'instant' is missing in the TS types in this version of TypeScript //
              // Can't update without tons of errors, so just casting it here //
              section.scrollIntoView(({ behavior: 'instant' } as unknown) as ScrollToOptions);
            }
            setIsOpen(true);
          }
          break;
        }
      }
    }
  }, [location.hash]);

  return (
    <S.Container
      id={getNavigationId(props.navigationTitle)}
      data-active={isOpen}
      data-navigation-id={getNavigationId(props.navigationTitle)}
    >
      <Container>
        {props.title && (
          <Column.Full>
            <S.Header onClick={() => setIsOpen(!isOpen)}>
              <S.HeaderInner>
                <S.Title>{props.title}</S.Title>

                {props.useLegacyContainer ? (
                  !isSSR && <S.Toggle>{isOpen ? <Minus /> : <Plus />}</S.Toggle>
                ) : (
                  <S.Toggle>{isOpen ? <Minus /> : <Plus />}</S.Toggle>
                )}
              </S.HeaderInner>
              {props.subHeader ? <>{props.subHeader}</> : null}
            </S.Header>
          </Column.Full>
        )}
        {isOpen ? (
          <Column.Full>
            <S.Content>{props.children}</S.Content>
          </Column.Full>
        ) : null}
        <Column.Full>
          <S.Footer></S.Footer>
        </Column.Full>
      </Container>
    </S.Container>
  );
};

export default LazyProductDetailsSection;
